import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
// import RaisedButton from 'material-ui/RaisedButton';

import PropTypes from 'prop-types'

export default class PopupLink extends React.Component {
  state = {
    open: this.props.defaultOpen || false
  };

  
  handleOpen = () => {
    this.setState({open: true});
  };
  
  handleClose = () => {
    this.setState({open: false});
  };
  
  handleAnchorClick = (e) => {
    e.preventDefault(); // prevents navigation to "#" (though, we can replace the anchor tag with a simple span and remove this)
    this.handleOpen();
  }
  
  render() {
    const actions = [
      <FlatButton
        label="Ok"
        primary={true}
        keyboardFocused={true}
        onClick={this.handleClose}
      />,
    ];
    const { linkText, popupContent } = this.props;

    return (
      <span>
        {/* <RaisedButton label="Dialog With Date Picker" onClick={this.handleOpen} /> */}
        <a href="#" onClick={this.handleAnchorClick}> {linkText} </a>
        <Dialog
          // title="Test Dialog title/header"
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >
          {popupContent}
        </Dialog>
      </span>
    );
  }
}

const propTypes = {
  linkText: PropTypes.string.isRequired,
  popupContent: PropTypes.any.isRequired 
  // children: PropTypes.any.isRequired
}

PopupLink.propTypes = propTypes



// WEBPACK FOOTER //
// ./src/components/PopupLink/index.js